export function novelRecoveryPrefix({ data_domain, account_id, pack_id }) {
  if (!data_domain || !account_id) return ''
  return `voko.story.authoring.v1:${encodeURIComponent(data_domain)}:${encodeURIComponent(account_id)}:${encodeURIComponent(pack_id)}:`
}

/** Remove only the named author's browser recovery records, never user-exported files. */
export function clearNovelRecovery({ account_id, data_domain }, store) {
  if (!account_id) return
  try {
    store ??= globalThis.localStorage
    if (!store) return
    const names = []
    for (let index = 0; index < store.length; index += 1) {
      const key = store.key(index)
      if (!key?.startsWith('voko.story.authoring.v1:')) continue
      const parts = key.split(':')
      if (parts[2] === encodeURIComponent(account_id) && (!data_domain || parts[1] === encodeURIComponent(data_domain))) names.push(key)
    }
    for (const key of names) store.removeItem(key)
  } catch { /* A privacy/storage restriction must not prevent logout. */ }
}
